module.exports = __webpack_public_path__ + "b64b558c64f8b34811c4c3efc06a0bd3.svg";